import { useEffect } from 'react';
import { sendCustomerSupportScreenLoadedEvent } from 'utils/analytics-events';

interface UseCustomerSupportReturn {
  // Add any business logic return values here if needed in the future
}

export const useCustomerSupport = (): UseCustomerSupportReturn => {
  useEffect(() => {
    sendCustomerSupportScreenLoadedEvent();
  }, []);

  return {};
};
